import { RolexContactFormMessage } from './Message'
import { RolexContactFormFields } from './Fields'
import { RolexContactFormForm } from './Form'
import { FC, useState } from 'react'
import { Container } from '@components/gassan-ui'
import { RolexImage } from '../Image'
import { SecondaryCta } from '@components/rolex-ui/SecondaryCta'
import { cn } from '@lib/cn'
import { RolexSendUsAMessage } from '@lib/kontent/models/RolexSendUsAMessage'
import { Item } from '@lib/kontent'
import { useTranslation } from 'next-i18next'
import { SendAMessageDisplayMode } from '@pages/rolex/contact/send-a-message'

type RolexContactFormModuleProps = {
  item: Item<RolexSendUsAMessage>
  backgroundColor?: 'lightBeige' | 'white'
}

export const RolexContactFormModule: FC<RolexContactFormModuleProps> = ({
  item,
  backgroundColor = 'lightBeige',
}) => {
  const [displayMode, setDisplayMode] = useState<SendAMessageDisplayMode>('message')
  const { t } = useTranslation('other')

  return (
    <div id="message-module">
      <RolexImage
        size="xl"
        mobileImage={item.elements.mobile_image}
        desktopImage={item.elements.desktop_image}
        className="!mb-0"
      />
      <div
        className={cn(
          backgroundColor === 'lightBeige' && 'bg-rolexLightBeige',
          backgroundColor === 'white' && 'bg-white',
          'py-[7vh]',
          'md:py-[7vh]',
        )}
      >
        <Container className={cn('relative grid grid-cols-6 gap-2', 'md:grid-cols-12')}>
          {displayMode === 'other-fields' && (
            <SecondaryCta
              iconLeft="chevron-left"
              className="absolute left-0 top-8"
              as="button"
              onClick={() => setDisplayMode('message')}
            >
              {t('back', { ns: 'other' })}
            </SecondaryCta>
          )}
          <div className="col-span-6  md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
            <RolexContactFormMessage item={item} displayMode={displayMode} />
            <RolexContactFormForm
              renderFields={
                <RolexContactFormFields
                  displayMode={displayMode}
                  setDisplayMode={setDisplayMode}
                  backgroundColor={backgroundColor === 'lightBeige' ? 'white' : 'lightBeige'}
                />
              }
              handleSuccessfullSubmit={() => setDisplayMode('success')}
            />
          </div>
        </Container>
      </div>
    </div>
  )
}
